import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
    Box, Paper, TextField, Button, Stack, Grid, TableContainer, Table, TableBody, TableCell, TableRow, TableHead, Checkbox,
    Select, MenuItem, Dialog, DialogTitle, IconButton, DialogContent, DialogContentText, DialogActions,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    ListItemText,
    Autocomplete,
    InputAdornment,
} from "@mui/material";
import { Colors } from '../../../Styles/Colors';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { localGetItem, localSetItem } from '../../../Utility/Services/CacheProviderService';
import Loader from '../../../Components/Loader';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import { ImagePaths } from '../../../Utility/ImagePaths';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Typography } from 'antd';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { appointment_Status_opt, Cancel_appointment_Status_opt, gstPercentage, Header_Filter_Fields } from '../../../Utility/Constants';

let DateFilterList = ['Default', 'Last 7 days', 'Last 15 days', 'Last 30 days']
let dayEndList = [
    { label: "Billing Desk", value: 1 },
    { label: "Module", value: 2 }
]

let bill_concession_list = [
    { label: "Bill Amount", value: 1 },
    { label: "Hospital Share", value: 2 }
]

const SEARCH_DRUG_NAME = [
    { label: 'Brand Name', value: 1 },
    { label: 'Generic Name', value: 2 },
    { label: 'Both', value: 3 },
]
const moduleToStateKeyMap = new Map([
    ["IP Credit Limit", "IP_Limit"],
    ["OP Credit Limit", "OP_Limit"],
    ["IP Lab Credit Limit", "LAB_Limit"],
    ["IP Pharmacy Credit Limit", "PHARMA_Limit"]
]);

const NewmoduleToStateKeyMap =new Map([
    ["Exceeded IP Credit Limit", "new_IP_Limit"],
    ["Exceeded OP Credit Limit", "new_OP_Limit"],
    ["Exceeded IP Pharmacy Credit Limit", "new_IP_PHARMA_Limit"],
    ["Exceeded OP Pharmacy Credit Limit", "new_OP_PHARMA_Limit"]
])

const fontVal = [
    {label: '7', value: 7 },
    {label: '8', value: 8 },
    {label: '9', value: 9 },
    {label: '10', value: 10 },
    {label: '11', value: 11 },
    {label: '12', value: 12 },
]

const spceVal = Array.from({ length: 11 }, (_, i) => {
    const value = i;
    return {
      label: value === 0 ? "Default" : value.toString(),
      value,
    };
  });

  const headSpace = Array.from({ length: 25 }, (_, i) => {
    const value = i - 14;
    return {
      label: value === 0 ? "Default" : value.toString(),
      value,
    };
  });
 

const Lab_Status_List = [
    "Before Specimen Collection",
    "Before Result Saved",
    "Before Result Completion",
    "After Result completed"
]
  
  

const disableCheckboxList = new Set([
    'Day End Based',
    'Auto log out time',
    'Show Header Footer in Discharge Summary Print',
    'Overall Concession Based On',
    'Appointment Status Configuration',
    'Patient Search Extra Filter Fields',
    'Discharge Summary Fontsize',
    'Discharge Summary Line Spacing',
    'Discharge Summary Head Spacing',
    'Doctor visit report view should be',
    'Display Consultant Name In Print',
    'Prescription Search Based On',
    'Set the default filter option for Credit Bills in Billing Transactions',
    'Mapping of Opthometrist',
    'Discharge Summary Left Margin',
    'Enable the Cancel Appointment option for the selected status',
    'No. of Days Allowed for Future Appointment in QuickBilling'
]);

const show_consultant_in_print = [
    { value: "dischargeSummary", is_checked: false, is_default: true, label: "Discharge Summary" },
    { value: "summarybillprint", is_checked: false, is_default: true, label: "Summary Bill Print" },
    { value: "ipDetailedBillPrint", is_checked: false, is_default: true, label: "IP Detailed Bill Print" },
]

let isNewBilling = null;
let userData = null;
class CustomConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Custom_Config_List: [],
            Block_IP: false,
            Block_OP: false,
            Block_LAB: false,
            Block_PHARMA: false,
            IP_Limit: 0,
            OP_Limit: 0,
            LAB_Limit: 0,
            PHARMA_Limit: 0,
            IP_Room_Bill: 0,
            Block_IP_new:false,
            Block_OP_new:false,
            Block_IP_pharama_new:false,
            Block_OP_pharama_new:false,
            new_IP_Limit:0,
            new_OP_Limit:0,
            new_IP_PHARMA_Limit:0,
            new_OP_PHARMA_Limit:0,
            Block_IP_Room_Bill: false,
            OPnoShow: false,
            auto_log_out_time: false,
            isLoader: false,
            LinkPharmaBilltoFO: false,
            pharmaCreditPay: false,
            billNO_Dissum: false,
            duplicateWatermark: false,
            showDisSumDateAndTime: false,
            allow_billing_date_fo: false,
            allow_billing_date_range: 'Default',
            PharmaFOLinkPoP: {},
            allow_separate_detailed_bill: false,
            disableBtn: false,
            block_room_charges_in_detailed_bill: false,
            default_pay_from_advance_for_checkout: false,
            show_op_appointment_time_in_pdf: false,
            show_ip_admission_time_in_pdf: false,
            show_bill_invoice_time_in_pdf: false,
            block_radiology_bills_in_fo: false,
            allow_doctor_fees_split_up: false,
            copy_ip_medication_to_discharge_summary: false,
            show_bill_description_in_receipt_bill: false,
            show_receipt_description_in_detailed_bill_print: false,
            show_discharge_summary_header_footer_in_all_pages: "true",
            automatic_opthometrist_mapping: "true",
            day_end_basis: dayEndList,
            day_end_type: 1,
            show_day_end_basis: false,
            logoutTime: 15,
            billing_concession_type: 1,
            unlock_doctor_notes_in_doctor_module: false,
            op_ip_service_code: false,
            radiology_service_code: false,
            display_latest_token_number:false,
            appointment_status: appointment_Status_opt,
            cancel_appointment_status: Cancel_appointment_Status_opt,
            appointment_status_check: false,
            lab_test_code: false,
            header_filter_fields: JSON.parse(JSON.stringify(Header_Filter_Fields)),
            appointment_with_doctor_only_one: false,
            lab_cancel_bill: false,
            lab_con_name_mandatory: false,
            lab_con_name_specialization: false,
            auto_fetch_bill_amount_to_payment: true,
            discharge_type_in_discharge_summary: false,
            drug_search: 1,
            laterpage_patient_detail_in_ip_detail_print: true,
            show_discharge_time_in_ip_detail_print: true,
            // show_visiting_consultant_in_disSum_print:false,
            ip_corporate_and_insurance_name_in_ip_bill_print: false,
            op_corporate_and_insurance_name_in_op_bill_print: false,
            rad_corporate_and_insurance_name_in_rad_bill_print: false,
            lab_corporate_and_insurance_name_in_lap_bill_print: false,
            discharge_summary_fontsize: 0,
            discharge_summary_linespacing: 0,
            discharge_summary_head_spacing: 0,
            is_room_charge_gst_applicable:false,
            minimum_room_charge_amount:'',
            gst_percentage:'',
            Show_lab_result_print_patient_details_in_lateral_page: false,
            dvr_preview_print: 'newtab',
            show_prepared_by_in_ip_detailed_bill_print: true,
            require_terms_and_conditions: false,
            discharge_summary_first_para_space: false,
            show_prepared_by_in_discharge: false,
            visit_consultant_view: JSON.parse(JSON.stringify(show_consultant_in_print)),
            allow_pharmacy_bills_in_credit_settlement: false,
            ot_surgery_auto_fetch:false,
            default_filter_option_for_credit_bills: "admission_wise",
            GSTAmount: '',
            GSTList: gstPercentage || [],
            GSTPercent : null,
            show_address_mobile_in_ipdetailed_print : false,
            co_payment_option_for_insurance : false,
            is_transaction_number_mandatory:false,
            is_admission_datetime_editable:false,
            show_selective_days_in_prescription:false,
            is_expense_maximum_enabled:false,
            expense_maximum_amount:'',
            no_of_days_allowed_for_future_op_billing:'',
            deduct_expense_at_day_end:false,
            set_due_date_for_credit_billing: true,
            show_vitals_as_key_value: true,
            op_test_report_payment_check:false,
            discharge_summary_left_margin: '1',
            enable_specialization_auto_bill: true,
            enable_ip_order_settlement: true,
            show_pharmacy_transactions_detailed_bill: false,
            need_draftcopy_watermark: true,
            allow_patient_credit_bills: false,
            enable_drug_alert: false,
            show_patient_tag_filter: false,
            allow_ip_request_cancel_in_pharmacy:false,
            tele_request_doctor_specialization_mandatory: false,
            enable_op_billing_access_for_ip_patient: false,
        }
    }

    componentDidMount() {
        this.GetCustomDatas()
        isNewBilling = localGetItem('isNewBilling') === 'true' ? true : false;
        userData = JSON.parse(localGetItem("loggedInUserInfo"));
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    GetCustomDatas() {
        try {
            this.LoaderFunction(true)
            let LoggedData = JSON.parse(localGetItem("loggedInUserInfo"))
            RestAPIService.getAllTwo(Serviceurls.CUSTOM_CONFIG).
                then((response) => {
                    if (response.data.status === "success") {
                        let NewObject = [
                            { "module": "OP Appointment No Show" },
                            { "module": "Show Pharmacy Bills in FO" },
                            { "module": "Complete Pharmacy Credit in Front Office" },
                            { "module": "Generate Bill Number for Discharge Summary" },
                            { "module": "Duplicate Bill Watermark" },
                            { 'module': "Show Discharge Time in Discharge Summary" },
                            { 'module': "Show Admission Time in Bills" },
                            { 'module': "Show Appointment Time in Bills" },
                            { 'module': "Show Invoice Time in Bills" },
                            { 'module': "Disable Billing Date" },
                            { 'module': "Show Receipts and Bills separately in Detailed Bill" },
                            { 'module': "Block Room Charge Sepration in Detailed Bill" },
                            ...(!isNewBilling ? [{ 'module': 'Show Radiology Bills in FO' }] : []),
                            { 'module': "Hospital/Doctor share split up" },
                            { 'module': "Default Pay From Advance Option for Checkout" },
                            { 'module': "Copy IP Medication to Discharge Summery" },
                            { 'module': "Show Bill Description in Receipt Bills" },
                            { 'module': "Show Receipt Description in Detailed bill Print" },
                            { 'module': "Allow IP Request Cancel in Pharmacy" },
                            { 'module': "Day End Based" },
                            { 'module': "Auto log out time" },
                            { 'module': "Show Header Footer in Discharge Summary Print" },
                            ...(!isNewBilling ? [{ 'module': 'Overall Concession Based On' }] : []),
                            { 'module': 'Lock Addendum in Doctor Module' },
                            ...(!isNewBilling ? [{ "module": "Disable OP and IP Service Code" }] : []),
                            { 'module': 'Appointment Status Configuration' },
                            ...(!isNewBilling ? [{ 'module': 'Disable Lab Test Code' }] : []),
                            { 'module': 'Patient Search Extra Filter Fields' },
                            { 'module': 'Allow only one "with doctor" status at a time' },
                            { 'module': 'Disable Lab Cancel Bill After Completed' },
                            { 'module': 'Lab Consultant Name Mandatory' },
                            { 'module': 'Show Lab Consultant Name with Specialization' },
                            ...(!isNewBilling ? [{ "module": "Disable Radiology Service Code" }] : []), 
                            { 'module': 'Should the bill amount be auto-fetched' },
                            { 'module': 'Show Discharge Type in Discharge Summary Print' },
                            { 'module': 'Prescription Search Based On' },
                            ...(userData?.token_gen_type==="Doctor" ? [{ "module": "Display Latest Token Number" }] : []),
                            
                            // { 'module': 'Show minimal header details on the lateral pages of the IP detailed bill print' },
                            // { 'module': 'Show Discharge Time in IP detailed bill Print' },
                            { 'module': 'Show IP Corporate and Insurance Name in IP Bill Print' },
                            { 'module': 'Show OP Corporate and Insurance Name in OP Bill Print' },
                            { 'module': 'Show Radiology Corporate and Insurance Name in Radiology Bill Print' },
                            { 'module': 'Show Lab Corporate and Insurance Name in Lab Bill Print' },
                            { 'module': 'Discharge Summary Fontsize' },
                            { 'module': 'Discharge Summary Line Spacing' },
                            { 'module': 'Discharge Summary Head Spacing' },
                            ...(isNewBilling ? [{'module':'Should GST be applicable for Room Rents ?'}] : []),
                            ...(userData?.print_report_configuration !== 3 ? [{ 'module': 'Show lab result print patient details in lateral page' }] : []),
                            // { 'module': 'Show Prepared By in IP Detailed bill Print' },
                            // { 'module': 'Show visiting consultant in Discharge summary print' },
                            { 'module': 'Doctor visit report view should be' },
                            // { 'module': 'Show Terms and conditions sentence in IP Detailed Bill Print' },
                            { 'module': 'Discharge Summary, Should the First Paragraph Start with a Space?' },
                            { 'module': 'Show prepared by in Discharge summary print'},
                            { 'module': 'Display Consultant Name In Print' },
                            { 'module': 'Show Pharmacy Bills in Credit Settlement'},
                            { 'module': 'Set the default filter option for Credit Bills in Billing Transactions'},
                            { 'module': 'Do the system requires a Transaction Number Mandatory'},
                            { 'module': 'Modify the Existing Date and Time of IP Admission'},
                            { 'module': 'Set Maximum Limit For Expense'},
                            ...(isNewBilling ? [{ 'module': 'No. of Days Allowed for Future Appointment in QuickBilling'}]: []),
                            { 'module': 'Deduct Expense In Day-End'},
                            ...(isNewBilling ? [{ 'module': 'Should OT Bill Auto Fetch' }] : []),
                            // ...(isNewBilling ? [{ 'module': 'Show Patient address and mobile number in IP Detailed bill print' }] : []),
                            // ...(isNewBilling ? [{ 'module': 'Co-Payment Option for insurance patients' }] : []),
                            { 'module': 'Show Days Selection in prescription' },
                            ...(isNewBilling && LoggedData?.is_opt ? [{ 'module': 'Mapping of Opthometrist' }] : []),
                            {module: 'Show Vitals as Key values in DVR print'},
                            { 'module': 'Lab and Radiology Test Report Payment Check'},
                            { 'module': 'Discharge Summary Left Margin' },
                            ...(isNewBilling ? [{ 'module': 'Specialization Based Auto Billing' }] : []),
                            ...(isNewBilling ? [{ 'module': 'Set the date for credit follow-up reminders to track and recover due payments' }] : []),
                            ...(isNewBilling ? [{ 'module': 'Show Pharmacy transactions in OP Detailed Bill Print' }] : [{ 'module': 'Show Pharmacy transactions in IP/OP Detailed Bill Print' }]),
                            { 'module': 'Need Draft Copy watermark for incomplete discharge summary' },
                            { 'module': 'Allow patient credit bills?' },
                            ...(isNewBilling ? [{ 'module': 'Collect advance payment against IP orders' }] : []),
                            { 'module': 'Should open High-Risk, Look-Alike, Sound-Alike Alert Popup?' },
                            { "module" : 'Enable the Cancel Appointment option for the selected status'},
                            { 'module': 'Show Patient Tag Filter'},
                            { 'module': 'Doctor Name and Specialization Mandatory in Tele Request?' },
                            { 'module': 'Enable OP billing access for IP patient' },

                        ] 
                    this.setState({
                        Custom_Config_List: isNewBilling 
                            ? [...(Array.isArray(response.data.data?.ip_credit_limit_new) ? response.data.data?.ip_credit_limit_new : []), ...NewObject] 
                            : [...(Array.isArray(response.data.data?.ip_credit_limit) ? response.data.data.ip_credit_limit : []), ...NewObject] ,
                    }, () => {
                            let states = this.state
                            for (let i = 0; this.state.Custom_Config_List.length > i; i++) {
                                switch (states.Custom_Config_List[i].module) {
                                    case "Exceeded IP Credit Limit": this.setState({ new_IP_Limit: states.Custom_Config_List[i].credit_limit, Block_IP_new: !states.Custom_Config_List[i].is_active })
                                        break;
                                    case "Exceeded OP Credit Limit": this.setState({ new_OP_Limit: states.Custom_Config_List[i].credit_limit, Block_OP_new: !states.Custom_Config_List[i].is_active })
                                        break;
                                    case "Exceeded IP Pharmacy Credit Limit": this.setState({ new_IP_PHARMA_Limit: states.Custom_Config_List[i].credit_limit, Block_IP_pharama_new: !states.Custom_Config_List[i].is_active })
                                        break;
                                    case "Exceeded OP Pharmacy Credit Limit": this.setState({ new_OP_PHARMA_Limit: states.Custom_Config_List[i].credit_limit, Block_OP_pharama_new: !states.Custom_Config_List[i].is_active })
                                        break;
                                    case "IP Credit Limit": this.setState({ IP_Limit: states.Custom_Config_List[i].credit_limit, Block_IP: states.Custom_Config_List[i].allow_overdue })
                                        break;
                                    case "OP Credit Limit": this.setState({ OP_Limit: states.Custom_Config_List[i].credit_limit, Block_OP: states.Custom_Config_List[i].allow_overdue })
                                        break;
                                    case "IP Lab Credit Limit": this.setState({ LAB_Limit: states.Custom_Config_List[i].credit_limit, Block_LAB: states.Custom_Config_List[i].allow_overdue })
                                        break;
                                    case "IP Pharmacy Credit Limit": this.setState({ PHARMA_Limit: states.Custom_Config_List[i].credit_limit, Block_PHARMA: states.Custom_Config_List[i].allow_overdue })
                                        break;
                                    case "IP Room Charge Auto Billing": this.setState({ IP_Room_Bill: states.Custom_Config_List[i].credit_limit, Block_IP_Room_Bill: states.Custom_Config_List[i].allow_overdue })
                                        break;
                                    case "OP Appointment No Show": this.setState({ OPnoShow: !response.data.data?.allow_no_show_update })
                                        break;
                                    case "Show Pharmacy Bills in FO": this.setState({ LinkPharmaBilltoFO: !response.data.data?.show_pharmacy_bills_in_fo })
                                        break;
                                    case "Complete Pharmacy Credit in Front Office": this.setState({ pharmaCreditPay: !response.data.data?.allow_fo_pharmacy_bill_complete })
                                        break;
                                    case "Generate Bill Number for Discharge Summary": this.setState({ billNO_Dissum: !response.data?.data?.allow_generate_bill_discharge_summary })
                                        break;
                                    case "Duplicate Bill Watermark": this.setState({ duplicateWatermark: !response.data?.data?.allow_duplicate_watermark })
                                        break;
                                    case "Show Discharge Time in Discharge Summary": this.setState({ showDisSumDateAndTime: !response.data?.data?.show_discharge_time_in_discharge_summary })
                                        break;
                                    case "Show Admission Time in Bills": this.setState({ show_ip_admission_time_in_pdf: !response.data?.data?.show_ip_admission_time_in_pdf })
                                        break;
                                    case "Show Appointment Time in Bills": this.setState({ show_op_appointment_time_in_pdf: !response.data?.data?.show_op_appointment_time_in_pdf })
                                        break;
                                    case "Show Invoice Time in Bills": this.setState({ show_bill_invoice_time_in_pdf: !response.data?.data?.show_bill_invoice_time_in_pdf })
                                        break;
                                    case "Disable Billing Date": this.setState({
                                        allow_billing_date_fo: !response.data?.data?.allow_billing_date_fo,
                                        allow_billing_date_range: response.data?.data?.allow_billing_date_range ? response.data?.data?.allow_billing_date_range : "Default"
                                    })
                                        break;
                                    case "Show Receipts and Bills separately in Detailed Bill": this.setState({ allow_separate_detailed_bill: !response.data?.data?.allow_separate_detailed_bill })
                                        break;
                                    case "Block Room Charge Sepration in Detailed Bill": this.setState({ block_room_charges_in_detailed_bill: response.data?.data?.block_room_charges_sepration_in_detailed_bill })
                                        break;
                                    case "Show Radiology Bills in FO": this.setState({ block_radiology_bills_in_fo: !response.data?.data?.block_radiology_bills_in_fo })
                                        break;
                                    case "Hospital/Doctor share split up": this.setState({ allow_doctor_fees_split_up: !response.data?.data?.allow_doctor_fees_split_up })
                                        break
                                    case "Default Pay From Advance Option for Checkout": this.setState({ default_pay_from_advance_for_checkout: !response.data?.data?.default_pay_from_advance_for_checkout })
                                        break;
                                    case "Copy IP Medication to Discharge Summery": this.setState({ copy_ip_medication_to_discharge_summary: !response.data?.data?.copy_ip_medication_to_discharge_summary })
                                        break;
                                    case "Show Bill Description in Receipt Bills": this.setState({ show_bill_description_in_receipt_bill: !response.data?.data?.show_bill_description_in_receipt_bill })
                                        break;
                                    case "Show Receipt Description in Detailed bill Print": this.setState({ show_receipt_description_in_detailed_bill_print: !response.data?.data?.show_receipt_description_in_detailed_bill_print })
                                        break;
                                    case "Allow IP Request Cancel in Pharmacy": this.setState({ allow_ip_request_cancel_in_pharmacy: !response.data?.data?.allow_ip_request_cancel_in_pharmacy })
                                        break;
                                    case "Day End Based": this.setState({
                                        show_day_end_basis: response.data?.data?.show_day_end_basis,
                                        day_end_type: response.data?.data?.day_end_type ? response.data?.data?.day_end_type : 1
                                    })
                                        break;
                                    case "Auto log out time": this.setState({ logoutTime: response.data?.data?.auto_log_out_time ? response.data?.data?.auto_log_out_time : 30 })
                                        break;
                                    case "Show Header Footer in Discharge Summary Print": this.setState({ show_discharge_summary_header_footer_in_all_pages: response.data?.data?.show_discharge_summary_header_footer_in_all_pages ? "true" : 'false' })
                                        break;
                                    case "Mapping of Opthometrist": this.setState({ automatic_opthometrist_mapping: response.data?.data?.automatic_opthometrist_mapping ? "true" : 'false' })
                                        break;
                                    case 'Overall Concession Based On': this.setState({
                                        billing_concession_type: response.data?.data?.billing_concession_type ? response.data?.data?.billing_concession_type : 1
                                    })
                                        break;
                                    case "Lock Addendum in Doctor Module": this.setState({ unlock_doctor_notes_in_doctor_module: !response.data?.data?.unlock_doctor_notes_in_doctor_module })
                                        break;
                                    case 'Disable OP and IP Service Code': this.setState({ op_ip_service_code: !response.data?.data?.op_ip_service_code })
                                        break;
                                    case 'Appointment Status Configuration':
                                        this.setState({
                                            appointment_status: response.data?.data?.appointment_status ? response.data?.data?.appointment_status : appointment_Status_opt
                                        })
                                        break;
                                    case 'Enable the Cancel Appointment option for the selected status':
                                        this.setState({
                                            cancel_appointment_status: response.data?.data?.cancel_appointment_status ? response.data?.data?.cancel_appointment_status : Cancel_appointment_Status_opt
                                        })
                                        break;
                                    case 'Disable Lab Test Code':
                                        this.setState({ lab_test_code: !response.data?.data?.lab_test_code })
                                        break;
                                    case 'Patient Search Extra Filter Fields':
                                        this.setState(
                                            {
                                                header_filter_fields: response.data?.data?.header_filter_fields
                                                    ? JSON.parse(JSON.stringify(response.data.data.header_filter_fields))
                                                    : JSON.parse(JSON.stringify(Header_Filter_Fields))
                                            },
                                            () => {
                                                // Callback after header_filter_fields is set
                                                const updatedFields = [...this.state.header_filter_fields]; // Copy existing fields

                                                JSON.parse(JSON.stringify(Header_Filter_Fields)).forEach((newList) => {
                                                    // Check if the value already exists in updatedFields
                                                    const existsInUpdatedFields = updatedFields.some(
                                                        (field) => field.value === newList.value
                                                    );

                                                    // Add only if not present
                                                    if (!existsInUpdatedFields) {
                                                        updatedFields.push(newList);
                                                    }
                                                });

                                                // Update header_filter_fields with the new array
                                                this.setState({ header_filter_fields: updatedFields });
                                            }
                                        );
                                        break;
                                    case 'Allow only one "with doctor" status at a time':
                                        this.setState({ appointment_with_doctor_only_one: !response.data?.data?.appointment_with_doctor_only_one })
                                        break;
                                    case 'Disable Lab Cancel Bill After Completed':
                                        this.setState({ lab_cancel_bill: !response.data?.data?.lab_cancel_bill })
                                        break;
                                    case 'Lab Consultant Name Mandatory':
                                        this.setState({ lab_con_name_mandatory: !response.data?.data?.lab_con_name_mandatory })
                                        break;
                                    case 'Show Lab Consultant Name with Specialization':
                                        this.setState({ lab_con_name_specialization: !response.data?.data?.lab_con_name_specialization })
                                        break;
                                    case 'Disable Radiology Service Code':
                                        this.setState({ radiology_service_code: !response.data?.data?.radiology_service_code })
                                        break;
                                    case 'Display Latest Token Number':
                                        this.setState({ display_latest_token_number: !response.data?.data?.display_latest_token_number })
                                        break;
                                    case 'Should the bill amount be auto-fetched':
                                        this.setState({ auto_fetch_bill_amount_to_payment: !response.data?.data?.auto_fetch_bill_amount_to_payment })
                                        break;
                                    case 'Show Discharge Type in Discharge Summary Print':
                                        this.setState({ discharge_type_in_discharge_summary: !response.data?.data?.discharge_type_in_discharge_summary })
                                        break;
                                    case 'Prescription Search Based On':
                                        this.setState({ drug_search: response.data?.data?.drug_search })
                                        break;
                                    case 'Show minimal header details on the lateral pages of the IP detailed bill print':
                                        this.setState({ laterpage_patient_detail_in_ip_detail_print: !response.data?.data?.laterpage_patient_detail_in_ip_detail_print })
                                        break;
                                    case 'Show Discharge Time in IP detailed bill Print':
                                        this.setState({ show_discharge_time_in_ip_detail_print: !response.data?.data?.show_discharge_time_in_ip_detail_print })
                                        break;
                                    case 'Show IP Corporate and Insurance Name in IP Bill Print':
                                        this.setState({ ip_corporate_and_insurance_name_in_ip_bill_print: !response.data?.data?.ip_corporate_and_insurance_name_in_ip_bill_print })
                                        break;
                                    case 'Show OP Corporate and Insurance Name in OP Bill Print':
                                        this.setState({ op_corporate_and_insurance_name_in_op_bill_print: !response.data?.data?.op_corporate_and_insurance_name_in_op_bill_print })
                                        break;
                                    case 'Show Radiology Corporate and Insurance Name in Radiology Bill Print':
                                        this.setState({ rad_corporate_and_insurance_name_in_rad_bill_print: !response.data?.data?.rad_corporate_and_insurance_name_in_rad_bill_print })
                                        break;
                                    case 'Show Lab Corporate and Insurance Name in Lab Bill Print':
                                        this.setState({ lab_corporate_and_insurance_name_in_lap_bill_print: !response.data?.data?.lab_corporate_and_insurance_name_in_lap_bill_print })
                                        break;
                                    case 'Discharge Summary Fontsize':
                                        this.setState({ discharge_summary_fontsize: response.data?.data?.discharge_summary_fontsize || 0 })
                                        break;
                                    case 'Discharge Summary Line Spacing':
                                        this.setState({ discharge_summary_linespacing: response.data?.data?.discharge_summary_linespacing || 0 })
                                        break;
                                    case 'Discharge Summary Head Spacing':
                                        this.setState({ discharge_summary_head_spacing: response.data?.data?.discharge_summary_head_spacing || 0 })
                                        break;
                                    case 'Should GST be applicable for Room Rents ?':
                                        this.setState({ is_room_charge_gst_applicable: !response?.data?.data?.is_room_charge_gst_applicable || false, GSTAmount: response?.data?.data?.room_charge_gst_limit || '', GSTPercent: gstPercentage.find((item) => +item?.value === response?.data?.data?.room_charge_gst_percent) || null })
                                        break;
                                    case 'Show lab result print patient details in lateral page':
                                        this.setState({ Show_lab_result_print_patient_details_in_lateral_page: !response.data?.data?.Show_lab_result_print_patient_details_in_lateral_page })
                                        break;
                                    case 'Show Prepared By in IP Detailed bill Print':
                                        this.setState({  show_prepared_by_in_ip_detailed_bill_print: !response.data?.data?.show_prepared_by_in_ip_detailed_bill_print })
                                        break;
                                    // case 'Show visiting consultant in Discharge summary print':
                                    //     this.setState({  show_visiting_consultant_in_disSum_print: !response.data?.data?.discharge_include_visiting_consultant })
                                    //     break;
                                    case 'Doctor visit report view should be':
                                        this.setState({  dvr_preview_print: response.data?.data?.dvr_preview_print })
                                        break;
                                    case 'Show Terms and conditions sentence in IP Detailed Bill Print':
                                        this.setState({  require_terms_and_conditions: !response.data?.data?.require_terms_and_conditions })
                                        break;
                                    case 'Discharge Summary, Should the First Paragraph Start with a Space?':
                                        this.setState({  discharge_summary_first_para_space: !response.data?.data?.discharge_summary_first_para_space })
                                        break;
                                    case 'Show prepared by in Discharge summary print':
                                        this.setState({show_prepared_by_in_discharge: !response.data?.data?.show_prepared_by_in_discharge})
                                        break;
                                    case 'Show Pharmacy Bills in Credit Settlement':
                                        this.setState({allow_pharmacy_bills_in_credit_settlement: !response.data?.data?.allow_pharmacy_bills_in_credit_settlement})
                                        break;
                                    case 'Display Consultant Name In Print':
                                        this.setState((prevState) => {
                                            const data = response.data?.data?.visit_consultant_view;
                                            return ({
                                                ...prevState,
                                                visit_consultant_view: data
                                                    ? [
                                                        { value: "dischargeSummary", is_checked: data?.discharge_include_visiting_consultant, is_default: true, label: "Discharge Summary" },
                                                        { value: "summarybillprint", is_checked: data?.ip_summary_include_visiting_consultant, is_default: true, label: "Summary Bill Print" },
                                                        // { value: "ipDetailedBillPrint", is_checked: data?.ip_detail_include_visiting_consultant, is_default: true, label: "IP Detailed Bill Print" },
                                                    ]
                                                    : JSON.parse(JSON.stringify(show_consultant_in_print))
                                            })
                                        });
                                        break;
                                    case 'Should OT Bill Auto Fetch':
                                        this.setState({ot_surgery_auto_fetch: !response.data?.data?.ot_surgery_auto_fetch})
                                        break;
                                    case 'Set the default filter option for Credit Bills in Billing Transactions':
                                        this.setState({ default_filter_option_for_credit_bills: response.data?.data?.default_filter_option_for_credit_bills || "admission_wise" })
                                        break;
                                    case 'Show Patient address and mobile number in IP Detailed bill print':
                                        this.setState({ show_address_mobile_in_ipdetailed_print: !response.data?.data?.show_address_mobile_in_ipdetailed_print })
                                        break;
                                    case 'Co-Payment Option for insurance patients':
                                        this.setState({ co_payment_option_for_insurance: !response.data?.data?.co_payment_option_for_insurance})
                                        break;
                                    case 'Do the system requires a Transaction Number Mandatory':
                                        this.setState({ is_transaction_number_mandatory: !response.data?.data?.is_transaction_number_mandatory })
                                        break;
                                    case 'Modify the Existing Date and Time of IP Admission':
                                        this.setState({ is_admission_datetime_editable: !response.data?.data?.is_admission_datetime_editable })
                                        break;
                                    case 'Set Maximum Limit For Expense':
                                        this.setState({ is_expense_maximum_enabled: !response.data?.data?.is_expense_maximum_enabled ,expense_maximum_amount:response?.data?.data?.expense_maximum_amount || '' })
                                        break;
                                    case 'No. of Days Allowed for Future Appointment in QuickBilling':
                                        this.setState({ no_of_days_allowed_for_future_op_billing:response?.data?.data?.no_of_days_allowed_for_future_op_billing || '0' }) 
                                        break;
                                    case 'Deduct Expense In Day-End':
                                        this.setState({ deduct_expense_at_day_end: !response.data?.data?.deduct_expense_at_day_end })
                                        break;
                                    case 'Show Days Selection in prescription':
                                        this.setState({ show_selective_days_in_prescription: !response.data?.data?.show_selective_days_in_prescription })
                                        break;
                                    case 'Show Vitals as Key values in DVR print':
                                        this.setState({ show_vitals_as_key_value: !response.data?.data?.show_vitals_as_key_value })
                                        break;                                       
                                    case 'Lab and Radiology Test Report Payment Check':
                                        this.setState({ op_test_report_payment_check: !response.data?.data?.op_test_report_payment_check })
                                        break;
                                    case 'Discharge Summary Left Margin':
                                        this.setState({ discharge_summary_left_margin: response.data?.data?.discharge_summary_left_margin || "1" })
                                        break;
                                    case 'Specialization Based Auto Billing':
                                        this.setState({ enable_specialization_auto_bill: !response.data?.data?.enable_specialization_auto_bill })
                                        break;
                                    case 'Set the date for credit follow-up reminders to track and recover due payments':
                                        this.setState({ set_due_date_for_credit_billing: !response.data?.data?.set_due_date_for_credit_billing })
                                        break;
                                    case 'Show Pharmacy transactions in IP/OP Detailed Bill Print':
                                        this.setState({ show_pharmacy_transactions_detailed_bill: !response.data?.data?.show_pharmacy_transactions_detailed_bill })
                                        break;
                                    case 'Need Draft Copy watermark for incomplete discharge summary':
                                        this.setState({ need_draftcopy_watermark: !response.data?.data?.need_draftcopy_watermark })
                                        break;
                                    case 'Allow patient credit bills?':
                                        this.setState({ allow_patient_credit_bills: !response.data?.data?.allow_patient_credit_bills })
                                        break;
                                    case 'Collect advance payment against IP orders':
                                        this.setState({ enable_ip_order_settlement: !response.data?.data?.enable_ip_order_settlement })
                                        break;
                                    case 'Should open High-Risk, Look-Alike, Sound-Alike Alert Popup?':
                                        this.setState({ enable_drug_alert: !response.data?.data?.enable_drug_alert })
                                        break;
                                    case 'Show Patient Tag Filter':
                                        this.setState({ show_patient_tag_filter: !response.data?.data?.show_patient_tag_filter })
                                        break;
                                    case 'Doctor Name and Specialization Mandatory in Tele Request?':
                                        this.setState({ tele_request_doctor_specialization_mandatory: !response.data?.data?.mandatory_doc_name_spec_tele_request })
                                        break;
                                    case 'Enable OP billing access for IP patient':
                                        this.setState({ enable_op_billing_access_for_ip_patient: !response.data?.data?.enable_op_billing_access_for_ip_patient })
                                        break;
                                        
                                }
                            }
                        })
                        this.LoaderFunction(false)
                    }
                }).catch((e) => {
                    if (e?.response?.data?.status === 'fail') {
                        this.LoaderFunction(false)
                        this.errorMessage(e.response.data.message)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMessage(e.message)
                    }
                })
        }
        catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }

    updateCustomDetails = () => {
        try {
            let data = []
            let states = this.state
            this.setState({ disableBtn: true })
            data = {
                "ip_credit_limit": [
                    {
                        "module": "IP Credit Limit",
                        "credit_limit": +(states.IP_Limit),
                        "allow_overdue": states.Block_IP
                    },
                    {
                        "module": "OP Credit Limit",
                        "credit_limit": +(states.OP_Limit),
                        "allow_overdue": states.Block_OP
                    },
                    {
                        "module": "IP Lab Credit Limit",
                        "credit_limit": +(states.LAB_Limit),
                        "allow_overdue": states.Block_LAB
                    },
                    {
                        "module": "IP Pharmacy Credit Limit",
                        "credit_limit": +(states.PHARMA_Limit),
                        "allow_overdue": states.Block_PHARMA
                    },
                    {
                        "module": "IP Room Charge Auto Billing",
                        "credit_limit": +(states.IP_Room_Bill),
                        "allow_overdue": states.Block_IP_Room_Bill
                    }
                ],
                "ip_credit_limit_new": [
                    {
                        "module": "Exceeded IP Credit Limit",
                        "credit_limit": +(states.new_IP_Limit),
                        "is_active": !states.Block_IP_new,
                        "allow_overdue": true
                    },
                    {
                        "module": "Exceeded OP Credit Limit",
                        "credit_limit": +(states.new_OP_Limit),
                        "is_active": !states.Block_OP_new,
                        "allow_overdue": true
                    },
                    {
                        "module": "Exceeded IP Pharmacy Credit Limit",
                        "credit_limit": +(states.new_IP_PHARMA_Limit),
                        "is_active": !states.Block_IP_pharama_new,
                        "allow_overdue": true
                    },
                    {
                        "module": "Exceeded OP Pharmacy Credit Limit",
                        "credit_limit": +(states.new_OP_PHARMA_Limit),
                        "is_active": !states.Block_OP_pharama_new,
                        "allow_overdue": true
                    }
                ],
                "allow_no_show_update": !states?.OPnoShow,
                "allow_fo_pharmacy_bill_complete": !states?.pharmaCreditPay,
                "show_pharmacy_bills_in_fo": !states?.LinkPharmaBilltoFO,
                "allow_generate_bill_discharge_summary": !states?.billNO_Dissum,
                "allow_duplicate_watermark": !states?.duplicateWatermark,
                "show_discharge_time_in_discharge_summary": !states?.showDisSumDateAndTime,
                "show_ip_admission_time_in_pdf": !states?.show_ip_admission_time_in_pdf,
                "show_op_appointment_time_in_pdf": !states?.show_op_appointment_time_in_pdf,
                "show_bill_invoice_time_in_pdf": !states?.show_bill_invoice_time_in_pdf,
                "allow_billing_date_fo": !states?.allow_billing_date_fo,
                "allow_billing_date_range": states?.allow_billing_date_range,
                "allow_separate_detailed_bill": !states?.allow_separate_detailed_bill,
                "block_room_charges_sepration_in_detailed_bill": states?.block_room_charges_in_detailed_bill,
                "block_radiology_bills_in_fo": !states?.block_radiology_bills_in_fo,
                "allow_doctor_fees_split_up": !states?.allow_doctor_fees_split_up,
                "default_pay_from_advance_for_checkout": !states?.default_pay_from_advance_for_checkout,
                "copy_ip_medication_to_discharge_summary": !states?.copy_ip_medication_to_discharge_summary,
                "show_bill_description_in_receipt_bill": !states?.show_bill_description_in_receipt_bill,
                "show_receipt_description_in_detailed_bill_print": !states?.show_receipt_description_in_detailed_bill_print,
                "allow_ip_request_cancel_in_pharmacy": !states?.allow_ip_request_cancel_in_pharmacy,
                'day_end_type': states.day_end_type ? states.day_end_type : 1,
                "auto_log_out_time": this.state.logoutTime ? this.state.logoutTime : 15,
                "show_discharge_summary_header_footer_in_all_pages": this.state.show_discharge_summary_header_footer_in_all_pages === 'true' ? true : false,
                "automatic_opthometrist_mapping": this.state.automatic_opthometrist_mapping === 'true' ? true : false,
                'billing_concession_type': this.state.billing_concession_type ? this.state.billing_concession_type : 1,
                'unlock_doctor_notes_in_doctor_module': !states.unlock_doctor_notes_in_doctor_module,
                'op_ip_service_code': !states.op_ip_service_code,
                'appointment_status': states.appointment_status ? states.appointment_status :  appointment_Status_opt,
                'cancel_appointment_status': states.cancel_appointment_status ? states.cancel_appointment_status : Cancel_appointment_Status_opt,
                'lab_test_code': !states.lab_test_code,
                'header_filter_fields': states?.header_filter_fields ? states?.header_filter_fields : JSON.parse(JSON.stringify(Header_Filter_Fields)),
                'appointment_with_doctor_only_one': !states.appointment_with_doctor_only_one,
                'lab_cancel_bill': !states.lab_cancel_bill,
                'lab_con_name_mandatory': !states.lab_con_name_mandatory,
                'lab_con_name_specialization': !states.lab_con_name_specialization,
                'radiology_service_code': !states.radiology_service_code,
                'display_latest_token_number': !states.display_latest_token_number,
                'discharge_type_in_discharge_summary': !states.discharge_type_in_discharge_summary,
                'auto_fetch_bill_amount_to_payment': !states.auto_fetch_bill_amount_to_payment,
                'drug_search': states.drug_search ? states.drug_search : 1,
                'laterpage_patient_detail_in_ip_detail_print': !states.laterpage_patient_detail_in_ip_detail_print,
                'show_discharge_time_in_ip_detail_print': !states.show_discharge_time_in_ip_detail_print,
                'op_corporate_and_insurance_name_in_op_bill_print': !states.op_corporate_and_insurance_name_in_op_bill_print,
                'ip_corporate_and_insurance_name_in_ip_bill_print': !states.ip_corporate_and_insurance_name_in_ip_bill_print,
                'rad_corporate_and_insurance_name_in_rad_bill_print': !states.rad_corporate_and_insurance_name_in_rad_bill_print,
                'lab_corporate_and_insurance_name_in_lap_bill_print': !states.lab_corporate_and_insurance_name_in_lap_bill_print,
                'discharge_summary_fontsize': states.discharge_summary_fontsize,
                'discharge_summary_linespacing': states.discharge_summary_linespacing,
                'discharge_summary_head_spacing': states.discharge_summary_head_spacing,
                'is_room_charge_gst_applicable':!states.is_room_charge_gst_applicable,
                'Show_lab_result_print_patient_details_in_lateral_page': !states.Show_lab_result_print_patient_details_in_lateral_page,
                // 'discharge_include_visiting_consultant': !states.show_visiting_consultant_in_disSum_print,
                'dvr_preview_print': states.dvr_preview_print,
                'show_prepared_by_in_ip_detailed_bill_print': !states.show_prepared_by_in_ip_detailed_bill_print,
                'require_terms_and_conditions': !states.require_terms_and_conditions,
                'discharge_summary_first_para_space': !states.discharge_summary_first_para_space,
                'show_prepared_by_in_discharge': !states.show_prepared_by_in_discharge,
                'allow_pharmacy_bills_in_credit_settlement': !states.allow_pharmacy_bills_in_credit_settlement,
                'visit_consultant_view': {
                    discharge_include_visiting_consultant: states?.visit_consultant_view[0]?.is_checked,
                    ip_summary_include_visiting_consultant: states?.visit_consultant_view[1]?.is_checked,
                    // ip_detail_include_visiting_consultant: states?.visit_consultant_view[2]?.is_checked,
                },
                'ot_surgery_auto_fetch':!states.ot_surgery_auto_fetch,
                'default_filter_option_for_credit_bills': states.default_filter_option_for_credit_bills,
                'room_charge_gst_limit': +states.GSTAmount || 0,
                'room_charge_gst_percent': +states.GSTPercent?.value || 0,
                'show_address_mobile_in_ipdetailed_print': !states.show_address_mobile_in_ipdetailed_print,
                'co_payment_option_for_insurance': !states.co_payment_option_for_insurance,
                'is_transaction_number_mandatory': !states.is_transaction_number_mandatory,
                'is_admission_datetime_editable':!states.is_admission_datetime_editable,
                'show_selective_days_in_prescription':!states.show_selective_days_in_prescription,
                'is_expense_maximum_enabled':!states.is_expense_maximum_enabled,
                'expense_maximum_amount':+states.expense_maximum_amount || 0,
                'no_of_days_allowed_for_future_op_billing':+states.no_of_days_allowed_for_future_op_billing || '0',
                'deduct_expense_at_day_end':!states.deduct_expense_at_day_end,
                "set_due_date_for_credit_billing": !states.set_due_date_for_credit_billing,
                'show_vitals_as_key_value': !states.show_vitals_as_key_value,
                'discharge_summary_left_margin': states.discharge_summary_left_margin || '1',
                'op_test_report_payment_check': !states.op_test_report_payment_check,
                'enable_specialization_auto_bill': !states.enable_specialization_auto_bill,
                'show_pharmacy_transactions_detailed_bill': !states.show_pharmacy_transactions_detailed_bill,
                'need_draftcopy_watermark': !states.need_draftcopy_watermark,
                'enable_ip_order_settlement': !states.enable_ip_order_settlement,
                'allow_patient_credit_bills': !states.allow_patient_credit_bills,
                'enable_drug_alert': !states.enable_drug_alert,
                'show_patient_tag_filter' : !states.show_patient_tag_filter,
                'mandatory_doc_name_spec_tele_request':!states.tele_request_doctor_specialization_mandatory,
                'enable_op_billing_access_for_ip_patient':!states.enable_op_billing_access_for_ip_patient,
            }
            RestAPIService.updateWithOutId(data, Serviceurls.CUSTOM_CONFIG)
                .then((response => {
                    if (response.data.status === 'success') {
                        this.successMessage(response.data.message)
                        this.GetCustomDatas()
                        localSetItem(
                            "DocName_Spec_mandatory",
                            !states?.tele_request_doctor_specialization_mandatory
                        );
                        localSetItem(
                            "enable_billing_access",
                            !states?.enable_op_billing_access_for_ip_patient
                        );
                        localSetItem("noShowStatus", !states?.OPnoShow);
                        localSetItem("Show_Pharmacy_Bills_In_FO", !states?.LinkPharmaBilltoFO);
                        localSetItem("Allow_Pharma_CreditBill_In_FO", !states?.pharmaCreditPay);
                        localSetItem("Allow_DischargeSummary_BillNo", !states?.billNO_Dissum);
                        localSetItem("allow_billing_date_fo", !states?.allow_billing_date_fo);
                        localSetItem("allow_billing_date_range", states?.allow_billing_date_range ? states?.allow_billing_date_range : "Default");
                        localSetItem("Show_Radiology_Bills_In_FO", !states?.block_radiology_bills_in_fo);
                        localSetItem("allow_doctor_fees_split_up", !states?.allow_doctor_fees_split_up);
                        localSetItem("default_PayFromAdvance_On_Checkout", !states?.default_pay_from_advance_for_checkout);
                        localSetItem("Copy_IP_Mediction_To_DischargeSummery", !states?.copy_ip_medication_to_discharge_summary);
                        localSetItem("day_end_value", states.day_end_type ? states.day_end_type : 1);
                        localSetItem("auto_log_out_time", this.state.logoutTime ? this.state.logoutTime : 15);
                        localSetItem('billing_concession_type', this.state.billing_concession_type ? this.state.billing_concession_type : 1)
                        localSetItem('appointment_status', JSON.stringify(this.state.appointment_status ? this.state.appointment_status : appointment_Status_opt))
                        localSetItem('lab_test_code', !this.state.lab_test_code)
                        localSetItem('op_ip_service_code', !states.op_ip_service_code)
                        localSetItem('cancel_appointment_status', JSON.stringify(this.state.cancel_appointment_status ? this.state.cancel_appointment_status : Cancel_appointment_Status_opt))
                        localSetItem('lab_test_code', !this.state.lab_test_code)
                        localSetItem('op_ip_service_code', !states.op_ip_service_code)
                        localSetItem('lab_con_name_mandatory', !states.lab_con_name_mandatory)
                        localSetItem('lab_con_name_specialization', !states.lab_con_name_specialization)
                        localSetItem('radiology_service_code', !states.radiology_service_code)
                        localSetItem('display_latest_token_number', !states.display_latest_token_number)
                        localSetItem('auto_fetch_bill_amount_to_payment', !states.auto_fetch_bill_amount_to_payment)
                        localSetItem('drug_search', states.drug_search)
                        localSetItem('lab_cancel_bill',!states.lab_cancel_bill)
                        localSetItem('credit_bill_flt_config', states?.default_filter_option_for_credit_bills || 'admission_wise')
                        localSetItem('Show_PH_Bills_In_Credit_Settle', !states.allow_pharmacy_bills_in_credit_settlement)
                        localSetItem('co_payment_option_for_insurance', !states.co_payment_option_for_insurance)
                        localSetItem('is_transaction_number_mandatory', !states.is_transaction_number_mandatory)
                        localSetItem('is_admission_datetime_editable', !states.is_admission_datetime_editable)
                        localSetItem('show_selective_days_in_prescription', !states.show_selective_days_in_prescription)
                        localSetItem('is_expense_maximum_enabled', !states.is_expense_maximum_enabled)
                        localSetItem('expense_maximum_amount', states.expense_maximum_amount)
                        localSetItem('no_of_days_allowed_for_future_op_billing', states.no_of_days_allowed_for_future_op_billing || 0)
                        localSetItem('deduct_expense_at_day_end', states.deduct_expense_at_day_end)
                        localSetItem('enable_specialization_auto_bill', !states.enable_specialization_auto_bill)
                        localSetItem('set_due_date_for_credit_billing', !states.set_due_date_for_credit_billing)
                        localSetItem('automatic_opthometrist_mapping', states.automatic_opthometrist_mapping)
                        localSetItem('op_test_report_payment_check', !states.op_test_report_payment_check)
                        localSetItem('show_pharmacy_transactions_detailed_bill', !states.show_pharmacy_transactions_detailed_bill)
                        let GSTData = {
                            is_room_charge_gst_applicable: !states.is_room_charge_gst_applicable,
                            room_charge_gst_limit: +states.GSTAmount || 0,
                            room_charge_gst_percent: +states.GSTPercent?.value || 0
                        }
                        localSetItem('gst_room_charge', JSON.stringify(GSTData))
                        let LoggedData = JSON.parse(localGetItem("loggedInUserInfo"))
                        LoggedData.header_filter_fields = this.state.header_filter_fields ? JSON.parse(JSON.stringify(this.state.header_filter_fields)) : JSON.parse(JSON.stringify(Header_Filter_Fields))
                        userData = LoggedData;
                        localSetItem('loggedInUserInfo', JSON.stringify(LoggedData))
                        this.setState({ disableBtn: false })
                        localSetItem('allow_patient_credit_bills', !states.allow_patient_credit_bills)
                        localSetItem('enable_drug_alert', !states.enable_drug_alert)
                        localSetItem('ip_order_advance_adjust', !states.enable_ip_order_settlement)
                        localSetItem('show_patient_tag_filter', !states.show_patient_tag_filter)
                    }
                })).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        this.errorMessage(e.response.data.message)
                    } else {
                        this.errorMessage(e.message)
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (e) {
            this.setState({ disableBtn: false })
            this.errorMessage(e.message)
        }
    }
    onUnitChange = (type) => {
        if (type === "increment" && this.state.logoutTime >= 10) {
            this.setState({ logoutTime: this.state.logoutTime + 5 })

        } else if (type === "decrement" && this.state.logoutTime <= 60) {
            this.setState({ logoutTime: this.state.logoutTime - 5 })

        }
    }


    BlockBills = (item) => {
        let Module = item.module
        let states = this.state
        return (
            <Checkbox onChange={(event) => {
                switch (Module) {
                    case "Exceeded IP Credit Limit": this.setState({ Block_IP_new: event.target.checked })
                        break;
                    case "Exceeded OP Credit Limit": this.setState({ Block_OP_new: event.target.checked })
                        break;
                    case "Exceeded IP Pharmacy Credit Limit": this.setState({ Block_IP_pharama_new: event.target.checked })
                        break;
                    case "Exceeded OP Pharmacy Credit Limit": this.setState({ Block_OP_pharama_new: event.target.checked })
                        break;
                    case "IP Credit Limit": this.setState({ Block_IP: event.target.checked })
                        break;
                    case "OP Credit Limit": this.setState({ Block_OP: event.target.checked })
                        break;
                    case "IP Lab Credit Limit": this.setState({ Block_LAB: event.target.checked })
                        break;
                    case "IP Pharmacy Credit Limit": this.setState({ Block_PHARMA: event.target.checked })
                        break;
                    case "IP Room Charge Auto Billing": this.setState({ Block_IP_Room_Bill: event.target.checked })
                        break;
                    case "OP Appointment No Show": this.setState({ OPnoShow: event.target.checked })
                        break;
                    case "Show Pharmacy Bills in FO": this.setState({ PharmaFOLinkPoP: event.target.checked ? { state: "LinkPharmaBilltoFO", value: event.target.checked } : {}, LinkPharmaBilltoFO: event.target.checked ? this.state.LinkPharmaBilltoFO : false }, () => {
                        if (event.target.checked) {
                            if (!states?.LinkPharmaBilltoFO) {
                                this.setState({ pharmaCreditPay: true })
                            }
                        }else{
                            this.setState({ show_pharmacy_transactions_detailed_bill: false })
                        }
                    }) // warning popup opens
                        break;
                    case "Complete Pharmacy Credit in Front Office": this.setState({ PharmaFOLinkPoP: event.target.checked ? { state: "pharmaCreditPay", value: event.target.checked } : {}, pharmaCreditPay: event.target.checked ? this.state.pharmaCreditPay : false }) // warning popup opens
                        break;
                    case "Generate Bill Number for Discharge Summary": this.setState({ billNO_Dissum: event.target.checked })
                        break;
                    case 'Duplicate Bill Watermark': this.setState({ duplicateWatermark: event.target.checked })
                        break;
                    case 'Show Discharge Time in Discharge Summary': this.setState({ showDisSumDateAndTime: event.target.checked })
                        break;
                    case 'Show Admission Time in Bills': this.setState({ show_ip_admission_time_in_pdf: event.target.checked })
                        break;
                    case 'Show Appointment Time in Bills': this.setState({ show_op_appointment_time_in_pdf: event.target.checked })
                        break;
                    case 'Show Invoice Time in Bills': this.setState({ show_bill_invoice_time_in_pdf: event.target.checked })
                        break;
                    case "Disable Billing Date": this.setState({ allow_billing_date_fo: event.target.checked }, () => {
                        if (!states.allow_billing_date_fo) {
                            this.setState({ allow_billing_date_range: "Default" })
                        }
                    })
                        break;
                    case "Show Receipts and Bills separately in Detailed Bill": this.setState({ allow_separate_detailed_bill: event.target.checked })
                        break;
                    case "Block Room Charge Sepration in Detailed Bill": this.setState({ block_room_charges_in_detailed_bill: event.target.checked })
                        break;
                    case "Show Radiology Bills in FO": this.setState({ block_radiology_bills_in_fo: event.target.checked })
                        break;
                    case "Hospital/Doctor share split up": this.setState({ allow_doctor_fees_split_up: event.target.checked })
                        break;
                    case "Default Pay From Advance Option for Checkout": this.setState({ default_pay_from_advance_for_checkout: event.target.checked })
                        break;
                    case "Copy IP Medication to Discharge Summery": this.setState({ copy_ip_medication_to_discharge_summary: event.target.checked })
                        break;
                    case "Show Bill Description in Receipt Bills": this.setState({ show_bill_description_in_receipt_bill: event.target.checked })
                    case "Show Receipt Description in Detailed bill Print": this.setState({ show_receipt_description_in_detailed_bill_print: event.target.checked })
                        break;
                    case "Allow IP Request Cancel in Pharmacy": this.setState({ allow_ip_request_cancel_in_pharmacy: event.target.checked })
                        break;
                    case 'Day End Based': this.setState({ show_day_end_basis: event.target.checked }, () => {
                        if (!states.show_day_end_basis) {
                            this.setState({ day_end_type: 1 })
                        }
                    })
                        break;
                    case 'Lock Addendum in Doctor Module': this.setState({ unlock_doctor_notes_in_doctor_module: event.target.checked })
                        break;
                    case 'Appointment Status Configuration':
                        this.setState({ appointment_status_check: event.target.checked })
                        break;
                    case 'Disable Lab Test Code': this.setState({ lab_test_code: event.target.checked })
                        break;
                    case 'Allow only one "with doctor" status at a time': this.setState({ appointment_with_doctor_only_one: event.target.checked })
                        break;
                    case 'Disable OP and IP Service Code':
                        this.setState({ op_ip_service_code: event.target.checked })
                        break;
                    case 'Disable Lab Cancel Bill After Completed':
                        this.setState({ lab_cancel_bill: event.target.checked })
                        break;
                    case 'Lab Consultant Name Mandatory':
                        this.setState({ lab_con_name_mandatory: event.target.checked })
                        break;
                    case 'Show Lab Consultant Name with Specialization':
                        this.setState({ lab_con_name_specialization: event.target.checked })
                        break;
                    case 'Disable Radiology Service Code':
                        this.setState({ radiology_service_code: event.target.checked })
                        break;
                    case 'Display Latest Token Number':
                        this.setState({ display_latest_token_number: event.target.checked })
                        break;
                    case 'Should the bill amount be auto-fetched':
                        this.setState({ auto_fetch_bill_amount_to_payment: event.target.checked })
                        break;
                    case 'Show minimal header details on the lateral pages of the IP detailed bill print':
                        this.setState({ laterpage_patient_detail_in_ip_detail_print: event.target.checked })
                        break
                    case 'Show Discharge Time in IP detailed bill Print':
                        this.setState({ show_discharge_time_in_ip_detail_print: event.target.checked })
                        break;
                    case 'Show IP Corporate and Insurance Name in IP Bill Print':
                        this.setState({ ip_corporate_and_insurance_name_in_ip_bill_print: event.target.checked })
                        break;
                    case 'Show OP Corporate and Insurance Name in OP Bill Print':
                        this.setState({ op_corporate_and_insurance_name_in_op_bill_print: event.target.checked })
                        break;
                    case 'Show Radiology Corporate and Insurance Name in Radiology Bill Print':
                        this.setState({ rad_corporate_and_insurance_name_in_rad_bill_print: event.target.checked })
                        break;
                    case 'Show Lab Corporate and Insurance Name in Lab Bill Print':
                        this.setState({ lab_corporate_and_insurance_name_in_lap_bill_print: event.target.checked })
                        break;
                    case 'Should GST be applicable for Room Rents ?':
                        this.setState({ is_room_charge_gst_applicable:event.target.checked, GSTAmount:  '', GSTPercent: null })
                        break;
                    case 'Show lab result print patient details in lateral page':
                        this.setState({ Show_lab_result_print_patient_details_in_lateral_page: event.target.checked })
                        break;
                    case 'Show Terms and conditions sentence in IP Detailed Bill Print':
                        this.setState({ require_terms_and_conditions: event.target.checked })
                        break; 
                    case 'Discharge Summary, Should the First Paragraph Start with a Space?':
                        this.setState({ discharge_summary_first_para_space: event.target.checked })
                        break;
                    case 'Show prepared by in Discharge summary print':
                        this.setState({ show_prepared_by_in_discharge: event.target.checked })
                        break;
                    case 'Show Pharmacy Bills in Credit Settlement':
                        this.setState({ allow_pharmacy_bills_in_credit_settlement: event.target.checked })
                        break;
                    case 'Show Discharge Type in Discharge Summary Print':
                        this.setState({ discharge_type_in_discharge_summary: event.target.checked })
                        break;
                    case 'Show visiting consultant in Discharge summary print':
                        this.setState({ show_visiting_consultant_in_disSum_print: event.target.checked })
                        break;
                    case 'Show Prepared By in IP Detailed bill Print':
                        this.setState({ show_prepared_by_in_ip_detailed_bill_print: event.target.checked })
                        break;
                    case 'Do the system requires a Transaction Number Mandatory':
                        this.setState({ is_transaction_number_mandatory: event.target.checked })
                         break;
                    case 'Modify the Existing Date and Time of IP Admission':
                        this.setState({ is_admission_datetime_editable: event.target.checked })
                        break;
                    case 'Show Days Selection in prescription':
                        this.setState({ show_selective_days_in_prescription: event.target.checked })
                        break;
                    case 'Set Maximum Limit For Expense':
                        this.setState({ is_expense_maximum_enabled: event.target.checked }, () => {
                            if (!states.is_expense_maximum_enabled) {
                                this.setState({ expense_maximum_amount: '' })
                            }
                        })
                        break;
                    case 'Deduct Expense In Day-End':
                        this.setState({ deduct_expense_at_day_end: event.target.checked })
                        break;
                    case 'Should OT Bill Auto Fetch':
                        this.setState({ ot_surgery_auto_fetch: event.target.checked })
                        break;
                    case 'Show Patient address and mobile number in IP Detailed bill print':
                        this.setState({ show_address_mobile_in_ipdetailed_print: event.target.checked })
                        break;
                    case 'Co-Payment Option for insurance patients':
                        this.setState({ co_payment_option_for_insurance: event.target.checked })
                        break;
                    case 'Specialization Based Auto Billing':
                        this.setState({ enable_specialization_auto_bill: event.target.checked })
                        break;
                    case 'Set the date for credit follow-up reminders to track and recover due payments':
                        this.setState({set_due_date_for_credit_billing: event.target.checked})
                        break;
                    case 'Show Vitals as Key values in DVR print':
                        this.setState({ show_vitals_as_key_value: event.target.checked })
                        break;
                    case 'Lab and Radiology Test Report Payment Check':
                        this.setState({ op_test_report_payment_check: event.target.checked })
                        break;
                    case 'Show Pharmacy transactions in IP/OP Detailed Bill Print':
                        this.setState({ show_pharmacy_transactions_detailed_bill: event.target.checked })
                        break;
                    case 'Need Draft Copy watermark for incomplete discharge summary':
                        this.setState({ need_draftcopy_watermark: event.target.checked })
                        break;
                    case 'Allow patient credit bills?':
                        this.setState({ allow_patient_credit_bills: event.target.checked })
                        break;
                    case 'Collect advance payment against IP orders':
                        this.setState({ enable_ip_order_settlement: event.target.checked })
                        break;
                    case 'Should open High-Risk, Look-Alike, Sound-Alike Alert Popup?':
                        this.setState({ enable_drug_alert: event.target.checked })
                        break;
                    case 'Show Patient Tag Filter':
                        this.setState({ show_patient_tag_filter: event.target.checked })
                        break;
                    case 'Doctor Name and Specialization Mandatory in Tele Request?':
                        this.setState({ tele_request_doctor_specialization_mandatory: event.target.checked })
                        break;
                    case 'Enable OP billing access for IP patient':
                        this.setState({ enable_op_billing_access_for_ip_patient: event.target.checked })
                        break;
                }
            }}
                checked={
                Module === "IP Credit Limit" ? states.Block_IP
                : Module === "OP Credit Limit" ? states.Block_OP
                : Module === "IP Lab Credit Limit" ? states.Block_LAB
                : Module === "IP Pharmacy Credit Limit" ? states.Block_PHARMA
                : Module === "IP Room Charge Auto Billing" ? states.Block_IP_Room_Bill
                : Module === "OP Appointment No Show" ? states.OPnoShow
                : Module === "Complete Pharmacy Credit in Front Office" ? states.pharmaCreditPay
                : Module === "Generate Bill Number for Discharge Summary" ? states.billNO_Dissum
                : Module === "Show Pharmacy Bills in FO" ? states.LinkPharmaBilltoFO
                : Module === 'Duplicate Bill Watermark' ? states.duplicateWatermark
                : Module === 'Show Discharge Time in Discharge Summary' ? states.showDisSumDateAndTime
                : Module === 'Show Admission Time in Bills' ? states.show_ip_admission_time_in_pdf
                : Module === 'Show Appointment Time in Bills' ? states.show_op_appointment_time_in_pdf
                : Module === 'Show Invoice Time in Bills' ? states.show_bill_invoice_time_in_pdf
                : Module === "Disable Billing Date" ? states.allow_billing_date_fo
                : Module === "Show Receipts and Bills separately in Detailed Bill" ? states.allow_separate_detailed_bill
                : Module === "Block Room Charge Sepration in Detailed Bill" ? states.block_room_charges_in_detailed_bill
                : Module === "Show Radiology Bills in FO" ? states.block_radiology_bills_in_fo
                : Module === "Hospital/Doctor share split up" ? states.allow_doctor_fees_split_up
                : Module === "Default Pay From Advance Option for Checkout" ? states.default_pay_from_advance_for_checkout
                : Module === "Copy IP Medication to Discharge Summery" ? states.copy_ip_medication_to_discharge_summary
                : Module === "Show Receipt Description in Detailed bill Print" ? states.show_receipt_description_in_detailed_bill_print
                : Module === "Allow IP Request Cancel in Pharmacy" ? states.allow_ip_request_cancel_in_pharmacy
                : Module === 'Day End Based' ? states.show_day_end_basis
                : Module === "Lock Addendum in Doctor Module" ? states.unlock_doctor_notes_in_doctor_module
                : Module === "Show Bill Description in Receipt Bills" ? states.show_bill_description_in_receipt_bill
                : Module === 'Appointment Status Configuration' ? states.appointment_status_check
                : Module === 'Enable the Cancel Appointment option for the selected status' ? states.appointment_status_check
                : Module === 'Disable Lab Test Code' ? states.lab_test_code
                : Module === 'Allow only one "with doctor" status at a time' ? states.appointment_with_doctor_only_one
                : Module === 'Disable OP and IP Service Code' ? states.op_ip_service_code
                : Module === 'Disable Lab Cancel Bill After Completed' ? states.lab_cancel_bill
                : Module === 'Lab Consultant Name Mandatory' ? states.lab_con_name_mandatory
                : Module === 'Show Lab Consultant Name with Specialization' ? states.lab_con_name_specialization
                : Module === 'Should the bill amount be auto-fetched' ? states.auto_fetch_bill_amount_to_payment
                : Module === 'Disable Radiology Service Code' ? states.radiology_service_code
                : Module === 'Display Latest Token Number' ? states.display_latest_token_number
                : Module === 'Show Discharge Type in Discharge Summary Print' ? states.discharge_type_in_discharge_summary
                : Module === 'Show minimal header details on the lateral pages of the IP detailed bill print' ? states.laterpage_patient_detail_in_ip_detail_print
                : Module === 'Show Discharge Time in IP detailed bill Print' ? states.show_discharge_time_in_ip_detail_print
                : Module === 'Show IP Corporate and Insurance Name in IP Bill Print' ? states.ip_corporate_and_insurance_name_in_ip_bill_print
                : Module === 'Show OP Corporate and Insurance Name in OP Bill Print' ? states.op_corporate_and_insurance_name_in_op_bill_print
                : Module === 'Show Radiology Corporate and Insurance Name in Radiology Bill Print' ? states.rad_corporate_and_insurance_name_in_rad_bill_print
                : Module === 'Show Lab Corporate and Insurance Name in Lab Bill Print' ? states.lab_corporate_and_insurance_name_in_lap_bill_print
                : Module === 'Show prepared by in Discharge summary print' ? states.show_prepared_by_in_discharge
                : Module === 'Discharge Summary, Should the First Paragraph Start with a Space?' ? states.discharge_summary_first_para_space
                : Module === 'Show Terms and conditions sentence in IP Detailed Bill Print' ? states.require_terms_and_conditions
                : Module === 'Should GST be applicable for Room Rents ?' ? states.is_room_charge_gst_applicable
                : Module === 'Show lab result print patient details in lateral page' ? states.Show_lab_result_print_patient_details_in_lateral_page
                : Module === 'Show Prepared By in IP Detailed bill Print' ? states.show_prepared_by_in_ip_detailed_bill_print
                : Module === 'Show visiting consultant in Discharge summary print' ? states.show_visiting_consultant_in_disSum_print
                : Module === 'Do the system requires a Transaction Number Mandatory' ? states.is_transaction_number_mandatory
                : Module === 'Show Pharmacy Bills in Credit Settlement' ? states.allow_pharmacy_bills_in_credit_settlement
                : Module === 'Modify the Existing Date and Time of IP Admission' ? states.is_admission_datetime_editable
                : Module === 'Set Maximum Limit For Expense' ? states.is_expense_maximum_enabled
                : Module === 'Deduct Expense In Day-End' ? states.deduct_expense_at_day_end
                : Module === 'Should OT Bill Auto Fetch' ? states.ot_surgery_auto_fetch
                : Module === 'Show Patient address and mobile number in IP Detailed bill print' ? states.show_address_mobile_in_ipdetailed_print
                : Module === 'Co-Payment Option for insurance patients' ? states.co_payment_option_for_insurance
                : Module === 'Specialization Based Auto Billing' ? states.enable_specialization_auto_bill
                : Module === 'Show Days Selection in prescription' ? states.show_selective_days_in_prescription
                : Module === 'Set the date for credit follow-up reminders to track and recover due payments' ? states.set_due_date_for_credit_billing
                : Module === 'Show Vitals as Key values in DVR print' ? states.show_vitals_as_key_value
                : Module === 'Lab and Radiology Test Report Payment Check' ? states.op_test_report_payment_check
                : Module === 'Show Pharmacy transactions in IP/OP Detailed Bill Print' ? states.show_pharmacy_transactions_detailed_bill
                : Module === 'Need Draft Copy watermark for incomplete discharge summary' ? states.need_draftcopy_watermark
                : Module === 'Allow patient credit bills?' ? states.allow_patient_credit_bills
                : Module === 'Should open High-Risk, Look-Alike, Sound-Alike Alert Popup?' ? states.enable_drug_alert
                : Module === 'Exceeded IP Credit Limit' ? states.Block_IP_new
                : Module === 'Exceeded OP Credit Limit' ? states.Block_OP_new
                : Module === 'Exceeded IP Pharmacy Credit Limit' ? states.Block_IP_pharama_new
                : Module === 'Exceeded OP Pharmacy Credit Limit' ? states.Block_OP_pharama_new
                : Module === 'Collect advance payment against IP orders' ? states.enable_ip_order_settlement
                : Module === 'Show Patient Tag Filter' ? states.show_patient_tag_filter
                : Module === 'Doctor Name and Specialization Mandatory in Tele Request?' ? states.tele_request_doctor_specialization_mandatory
                : Module === 'Enable OP billing access for IP patient' ? states.enable_op_billing_access_for_ip_patient
 
                : false       
            }
                disabled={Module === 'Show Pharmacy transactions in IP/OP Detailed Bill Print' && !states.LinkPharmaBilltoFO ? true : Module === "Complete Pharmacy Credit in Front Office" ? states.LinkPharmaBilltoFO :
                    disableCheckboxList.has(Module) ? true : false} />
        )
    }

    CreditLimit = (item) => {
        let Module = item.module
        let states = this.state
        return (
            <Box>
                {
                    Module === 'Set Maximum Limit For Expense' ? 
                        <Box display={"flex"}>
                            <TextField
                                size='small'
                                variant="outlined"
                                disabled={states?.is_expense_maximum_enabled}
                                sx={{ width: '15vw', fontSize: '0.95vw' }}
                                value={this.state.expense_maximum_amount}
                                onChange={(event) => {
                                    let value = event.target.value;
                                    let isValid = CommonValidation.numberOnly(value);
                                    let numericValue = Number(value);
                                    if ((isValid || value === "") && (value === "" || (numericValue > 0 && value.length <= 10))) {
                                        this.setState({ expense_maximum_amount: event.target.value })
                                    }
                                }}
                            />
                        </Box> :
                    Module === 'No. of Days Allowed for Future Appointment in QuickBilling' ?
                        <Box display={"flex"}>
                             <TextField
                                size='small'
                                variant="outlined"
                                sx={{ width: '15vw', fontSize: '0.95vw' }}
                                value={this.state.no_of_days_allowed_for_future_op_billing || ''}
                                onChange={(event) => {
                                    let value = event.target.value;
                                    let isValid = CommonValidation.numberOnly(value);
                                    let numericValue = Number(value);
                                    if ((isValid || value === "") && (value === "" || (numericValue >= 0 && numericValue <= 100))) {
                                        this.setState({ no_of_days_allowed_for_future_op_billing: event.target.value })
                                    }
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end" >Days</InputAdornment>
                                }}
                            />
                        </Box> :
                    Module === "Disable Billing Date" ? 
                        <Box display={"flex"} justifyContent={"space-evenly"} alignItems={"center"}>
                            <label style={{ fontSize: "0.9vw", fontWeight: "bold" }}>{"Billing Allowed For"}</label>
                            <Select
                                disabled={!states.allow_billing_date_fo === false}
                                sx={{ width: "9vw", fontSize: "0.95vw" }}
                                size='small'
                                value={this.state.allow_billing_date_range}
                                onChange={(e) => { this.setState({ allow_billing_date_range: e.target.value }) }}
                            >
                                {DateFilterList?.length > 0 ? DateFilterList.map((item, index) => (
                                    <MenuItem sx={{ fontSize: "0.95vw" }} key={index} value={item}>{item}</MenuItem>
                                )) : null}
                            </Select>
                        </Box>
                        : Module === 'Day End Based' ?
                            <Box component={'div'}>
                                <Select
                                    sx={{ width: '15vw', fontSize: '0.95vw' }}
                                    size='small'
                                    value={this.state.day_end_type}
                                    onChange={(e) => { this.setState({ day_end_type: e.target.value }) }}
                                >
                                    {this.state.day_end_basis?.map((item, index) => (
                                        <MenuItem sx={{ fontSize: '0.95vw' }} key={index} value={item?.value}>{item?.label}</MenuItem>
                                    ))}
                                </Select>
                            </Box>
                            : Module === 'Auto log out time' ?
                                <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                    <IconButton
                                        color="secondary"
                                        onClick={() => { this.onUnitChange("decrement"); }}
                                        disabled={this.state.logoutTime <= 10}
                                        sx={{ width: '3vw', height: '3vh' }} // Adjust width and height as needed
                                    >
                                        <RemoveIcon />
                                    </IconButton>
                                    <Typography paddingX={"1vw"} sx={{ width: '50px', height: '50px', fontSize: "2vw" }} >
                                        {this.state.logoutTime}
                                    </Typography>
                                    <IconButton
                                        color="secondary"
                                        onClick={() => { this.onUnitChange("increment"); }}
                                        disabled={this.state.logoutTime >= 60}
                                        sx={{ width: '3vw', height: '3vh', }} // Adjust width and height as needed
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </Box>
                                : Module === 'Show Header Footer in Discharge Summary Print' ?
                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                        <FormControl>
                                            <RadioGroup
                                                sx={{ display: 'flex', flexDirection: 'row', width: "25vw" }}
                                                row
                                                value={this.state.show_discharge_summary_header_footer_in_all_pages}
                                                onChange={(e) => { this.setState({ show_discharge_summary_header_footer_in_all_pages: e.target.value }) }}
                                            >
                                                <FormControlLabel value="true" control={<Radio size='small' />} label="All Pages" />
                                                <FormControlLabel value="false" control={<Radio size='small' />} label="Only First and Last Page" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                : Module === 'Mapping of Opthometrist' ?
                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                        <FormControl>
                                            <RadioGroup
                                                sx={{ display: 'flex', flexDirection: 'row', width: "25vw" }}
                                                row
                                                value={this.state.automatic_opthometrist_mapping}
                                                onChange={(e) => { this.setState({ automatic_opthometrist_mapping: e.target.value }) }}
                                            >
                                                <FormControlLabel value="true" control={<Radio size='small' />} label="Automatic" />
                                                <FormControlLabel value="false" control={<Radio size='small' />} label="Manual" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                    : Module === 'Overall Concession Based On' ?
                                        <Box component={'div'}>
                                            <Select
                                                sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                size='small'
                                                value={this.state.billing_concession_type}
                                                onChange={(e) => { this.setState({ billing_concession_type: e.target.value }) }}
                                            >
                                                {bill_concession_list?.map((item, index) => (
                                                    <MenuItem sx={{ fontSize: '0.95vw' }} key={index} value={item?.value}>{item?.label}</MenuItem>
                                                ))}
                                            </Select>
                                        </Box> :
                                        Module === 'Enable the Cancel Appointment option for the selected status' ?
                                                    <Box component={'div'}>
                                                        <FormControl>
                                                            <Select
                                                                sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                size='small'
                                                                labelId="appointment-status-label"
                                                                multiple
                                                                value={this.state.cancel_appointment_status?.map((item) => item?.is_checked ? item?.label : '')}
                                                                renderValue={(selected) => selected?.join(",")?.replace(/,,/g, ",")}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 250,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {this.state.cancel_appointment_status?.map((option, index) => (
                                                                    <MenuItem key={option.label} value={option.label}>
                                                                        <Checkbox
                                                                            checked={option.is_checked}
                                                                            disabled={option?.is_default || this.state.appointment_status?.find((list)=>(list?.label === option.label && !list?.is_checked) )}
                                                                            onChange={(e) => {
                                                                                this.state.cancel_appointment_status[index]['is_checked'] = e.target.checked;
                                                                                // Handling "With Optometry" checkbox
                                                                                if (option.label === "With Optometry") {
                                                                                    const optometryCompletedIndex = this.state.cancel_appointment_status.findIndex(item => item.label === "Optometry Completed");
                                                                                    if (optometryCompletedIndex !== -1) {
                                                                                        if (e.target.checked) {
                                                                                            // Enable or disable "Optometry Completed" based on "With Optometry"
                                                                                            this.state.cancel_appointment_status[optometryCompletedIndex].is_default = false;
                                                                                        } else {
                                                                                            this.state.cancel_appointment_status[optometryCompletedIndex].is_default = true;
                                                                                            this.state.cancel_appointment_status[optometryCompletedIndex].is_checked = false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                this.setState({ cancel_appointment_status: this.state.cancel_appointment_status })
                                                                            }}
                                                                        />
                                                                        <ListItemText primary={option.label} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Box> :
                                        Module === 'Appointment Status Configuration' ?
                                                    <Box component={'div'}>
                                                        <FormControl>
                                                            <Select
                                                                sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                size='small'
                                                                labelId="appointment-status-label"
                                                                multiple
                                                                value={this.state.appointment_status?.map((item) => item?.is_checked ? item?.label : '')}
                                                                renderValue={(selected) => selected?.join(",")?.replace(/,,/g, ",")}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 250,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {this.state.appointment_status?.map((option, index) => (
                                                                    <MenuItem key={option.label} value={option.label}>
                                                                        <Checkbox
                                                                            disabled={option?.is_default}
                                                                            checked={option.is_checked}
                                                                            onChange={(e) => {
                                                                                this.state.appointment_status[index]['is_checked'] = e.target.checked;
                                                                                let CancelStatusInvalid = this.state.cancel_appointment_status?.find((list)=>list?.label === option?.label)
                                                                                if(CancelStatusInvalid?.is_checked && !e.target.checked){
                                                                                    let CancelStatusInvalidIndex = this.state.cancel_appointment_status?.findIndex((list)=>list?.label === option?.label)
                                                                                    this.state.cancel_appointment_status[CancelStatusInvalidIndex].is_checked = false;
                                                                                    this.warningMessage(`Cancel option is also unchecked for the "${option?.label}" status`)
                                                                                }
                                                                                // Handling "With Optometry" checkbox
                                                                                if (option.label === "With Optometry") {
                                                                                    const optometryCompletedIndex = this.state.appointment_status.findIndex(item => item.label === "Optometry Completed");
                                                                                    if (optometryCompletedIndex !== -1) {
                                                                                        if (e.target.checked) {
                                                                                            // Enable or disable "Optometry Completed" based on "With Optometry"
                                                                                            this.state.appointment_status[optometryCompletedIndex].is_default = false;
                                                                                        } else {
                                                                                            this.state.appointment_status[optometryCompletedIndex].is_default = true;
                                                                                            this.state.appointment_status[optometryCompletedIndex].is_checked = false;
                                                                                            let CancelStatusInvalid = this.state.cancel_appointment_status?.find((list) => list?.label === "Optometry Completed")
                                                                                            if (CancelStatusInvalid?.is_checked && !e.target.checked) {
                                                                                                let CancelStatusInvalidIndex = this.state.cancel_appointment_status?.findIndex((list) => list?.label === "Optometry Completed")
                                                                                                this.state.cancel_appointment_status[CancelStatusInvalidIndex].is_checked = false;
                                                                                                this.warningMessage(`Cancel option is also unchecked for the "Optometry Completed" status`)
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                this.setState({
                                                                                    appointment_status: this.state.appointment_status,
                                                                                    cancel_appointment_status: this.state?.cancel_appointment_status
                                                                                })
                                                                            }}
                                                                        />
                                                                        <ListItemText primary={option.label} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Box> :
                                            Module === 'Patient Search Extra Filter Fields' ?
                                                <Box component={'div'}>
                                                    <Select
                                                        sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                        size='small'
                                                        labelId="header-feilds-label"
                                                        multiple
                                                        value={this.state.header_filter_fields?.map((item) => item?.is_checked ? item?.label : '')}
                                                        renderValue={(selected) => selected?.join(",")?.replace(/,,/g, ",")}
                                                    >
                                                        {this.state.header_filter_fields?.map((option, index) => (
                                                            <MenuItem key={option.label} value={option.label}>
                                                                <Checkbox
                                                                    checked={option.is_checked}
                                                                    onChange={(e) => {
                                                                        if (this.state.header_filter_fields.every((list, eveIndex) => (list?.is_checked === false || (eveIndex === index && !e.target.checked)))) {
                                                                            this.errorMessage("Header Fields can't be empty.")
                                                                        } else {
                                                                            this.state.header_filter_fields[index]['is_checked'] = e.target.checked;
                                                                        }
                                                                        this.setState({ header_filter_fields: this.state.header_filter_fields })
                                                                    }}
                                                                />
                                                                <ListItemText primary={option.label} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box> : Module === 'Prescription Search Based On' ?
                                                    <Box component={'div'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                        <Select
                                                            size='small'
                                                            value={this.state.drug_search}
                                                            onChange={(e) => this.setState({ drug_search: e.target.value })}
                                                            sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                        >
                                                            {SEARCH_DRUG_NAME?.map((item, index) => {
                                                                return (
                                                                    <MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>
                                                                )
                                                            })}
                                                        </Select>
                                                    </Box>
                                                : moduleToStateKeyMap.has(Module) ?
                                                    <TextField
                                                    onChange={(e) => {
                                                        let isValid = CommonValidation.numberOnly(e.target.value)
                                                        if (e.target.value === "" || isValid) {
                                                            switch (Module) {
                                                                case "IP Credit Limit": this.setState({ IP_Limit: e.target.value })
                                                                    break;
                                                                case "OP Credit Limit": this.setState({ OP_Limit: e.target.value })
                                                                    break;
                                                                case "IP Lab Credit Limit": this.setState({ LAB_Limit: e.target.value })
                                                                    break;
                                                                case "IP Pharmacy Credit Limit": this.setState({ PHARMA_Limit: e.target.value })
                                                                    break;
                                                                case "IP Room Charge Auto Billing": this.setState({ IP_Room_Bill: e.target.value })
                                                                    break;
                                                            }
                                                        }
                                                    }} size="small"
                                                    value={states[moduleToStateKeyMap.get(Module)] || 0} /> 
                                                : NewmoduleToStateKeyMap.has(Module) ?
                                                    <TextField
                                                    onChange={(e) => {
                                                        let isValid = CommonValidation.numberOnly(e.target.value)
                                                        if (e.target.value === "" || isValid) {
                                                            switch (Module) {
                                                                case "Exceeded IP Credit Limit": this.setState({ new_IP_Limit: e.target.value })
                                                                    break;
                                                                case "Exceeded OP Credit Limit": this.setState({ new_OP_Limit: e.target.value })
                                                                    break;
                                                                case "Exceeded IP Pharmacy Credit Limit": this.setState({ new_IP_PHARMA_Limit: e.target.value })
                                                                    break;
                                                                case "Exceeded OP Pharmacy Credit Limit": this.setState({ new_OP_PHARMA_Limit: e.target.value })
                                                                    break;
                                                            }
                                                        }
                                                    }} size="small"
                                                    value={states[NewmoduleToStateKeyMap.get(Module)] || 0} /> 
                                                    : Module === 'Discharge Summary Fontsize' ?
                                                        <Box component={'div'}>
                                                            <Select
                                                                sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                size='small'
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        sx: {
                                                                            maxHeight: '30vh',
                                                                            overflowY: 'auto'
                                                                        }
                                                                    }
                                                                }}
                                                                value={this.state.discharge_summary_fontsize}
                                                                onChange={(e) => { this.setState({ discharge_summary_fontsize: e.target.value }) }}
                                                            >
                                                                <MenuItem sx={{}} value={0}>{'Default'}</MenuItem>
                                                                {fontVal?.map((item, index) => (
                                                                    <MenuItem sx={{ fontSize: '0.95vw' }} key={index} value={item?.value}>{item?.label}</MenuItem>
                                                                ))}
                                                            </Select>
                                                            </Box> 
                                                            : Module === 'Discharge Summary Line Spacing' ?
                                                            <Box component={'div'}>
                                                                <Select
                                                                    sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                    size='small'
                                                                    MenuProps={{
                                                                        PaperProps: {
                                                                            sx: {
                                                                                maxHeight: '30vh',
                                                                                overflowY: 'auto'
                                                                            }
                                                                        }
                                                                    }}
                                                                    value={this.state.discharge_summary_linespacing}
                                                                    onChange={(e) => { this.setState({ discharge_summary_linespacing: e.target.value }) }}
                                                                >
                                                                    {spceVal?.map((item, index) => (
                                                                        <MenuItem sx={{ fontSize: '0.95vw' }} key={index} value={item?.value}>{item?.label}</MenuItem>
                                                                    ))}
                                                                </Select>
                                                                </Box>  
                                                                : Module === 'Discharge Summary Head Spacing' ?
                                                                <Box component={'div'}>
                                                                    <Select
                                                                        sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                        size='small'
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                sx: {
                                                                                    maxHeight: '30vh',
                                                                                    overflowY: 'auto'
                                                                                }
                                                                            }
                                                                        }}
                                                                        value={this.state.discharge_summary_head_spacing}
                                                                        onChange={(e) => { this.setState({ discharge_summary_head_spacing: e.target.value }) }}
                                                                    >
                                                                        {headSpace?.map((item, index) => (
                                                                            <MenuItem sx={{ fontSize: '0.95vw', height: '2.5vw', minHeight: '2.5vw' }}  key={index} value={item?.value}>{item?.label}</MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </Box> 
                                                                : Module === 'Doctor visit report view should be' ?
                                                                <Box component={'div'}>
                                                                    <Select
                                                                            sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                            size='small'
                                                                            MenuProps={{
                                                                                PaperProps: {
                                                                                    sx: {
                                                                                        maxHeight: '30vh',
                                                                                        overflowY: 'auto'
                                                                                    }
                                                                                }
                                                                            }}
                                                                            value={this.state.dvr_preview_print}
                                                                            onChange={(e) => { this.setState({ dvr_preview_print: e.target.value }) }}
                                                                        >
                                                                            <MenuItem sx={{ fontSize: '0.95vw', height: '2.5vw', minHeight: '2.5vw' }} value={'newtab'}>{'New Tab'}</MenuItem>
                                                                            <MenuItem sx={{ fontSize: '0.95vw', height: '2.5vw', minHeight: '2.5vw' }} value={'popupview'}>{'Popup View'}</MenuItem>
                                                                        </Select>
                                                                    </Box>
                                                                    : Module === 'Should GST be applicable for Room Rents ?' ?
                                                                        <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                            <TextField
                                                                                size='small'
                                                                                variant="outlined"
                                                                                label="Apply GST When Rent Exceeds (₹)"
                                                                                disabled={states?.is_room_charge_gst_applicable}
                                                                                sx={{ width: '13.5vw', fontSize: '0.95vw' }}
                                                                                value={this.state.GSTAmount}
                                                                                onChange={(event) => {
                                                                                    let isValid = CommonValidation.numberOnly(event.target.value)
                                                                                    if ((isValid || event.target.value === "") && event.target.value?.length <= 10) {
                                                                                        this.setState({
                                                                                            GSTAmount: event.target.value
                                                                                        })
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <Autocomplete
                                                                                size='small'
                                                                                sx={{ width: '10vw', fontSize: '0.95vw', marginLeft: '1vw' }}
                                                                                options={this.state.GSTList ? this.state.GSTList : []}
                                                                                disabled={states?.is_room_charge_gst_applicable}
                                                                                getOptionLabel={(option) => (typeof (option) === "string" ? option : option?.label)}
                                                                                value={this.state?.GSTPercent}
                                                                                onChange={(event, newValue) => {
                                                                                    this.setState({ GSTPercent: newValue })
                                                                                }}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label={"Select GST (%)"}
                                                                                        disabled={states?.is_room_charge_gst_applicable}
                                                                                        InputProps={{
                                                                                            ...params.InputProps,
                                                                                            emed_tid: "gstReport_filter_selectServiceType"
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </Box>
                                                                        : Module === "Display Consultant Name In Print" ?
                                                                            <Box component={'div'}>
                                                                                <Select
                                                                                    sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                                    size='small'
                                                                                    labelId="header-feilds-label"
                                                                                    multiple
                                                                                    // value={this.state.visit_consultant_view?.map((item) => item?.is_checked ? item?.label : '')}
                                                                                    // renderValue={(selected) => selected?.join(",")?.replace(/,,/g, ",")}
                                                                                    value={this.state.visit_consultant_view?.filter(item => item?.is_checked).map(item => item?.label)}
                                                                                    renderValue={(selected) => selected.length > 0 ? selected.join(", ") : ""}
                                                                                >
                                                                                    {this.state.visit_consultant_view?.map((option, index) => (
                                                                                        <MenuItem key={option.label} value={option.label}>
                                                                                            <Checkbox
                                                                                                checked={option.is_checked}
                                                                                                onChange={(e) => {
                                                                                                    const updateList = [...this.state.visit_consultant_view]
                                                                                                    updateList[index]['is_checked'] = e.target.checked;
                                                                                                    this.setState({ visit_consultant_view: updateList })
                                                                                                }}
                                                                                            />
                                                                                            <ListItemText primary={option.label} />
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </Box>
                                                                            : Module === 'Set the default filter option for Credit Bills in Billing Transactions' ?
                                                                            <Box component={'div'}>
                                                                                <Select
                                                                                    sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                                    size='small'
                                                                                    MenuProps={{
                                                                                        PaperProps: {
                                                                                            sx: {
                                                                                                maxHeight: '30vh',
                                                                                                overflowY: 'auto'
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    value={this.state.default_filter_option_for_credit_bills}
                                                                                    onChange={(e) => { this.setState({ default_filter_option_for_credit_bills: e.target.value }) }}
                                                                                >
                                                                                    <MenuItem sx={{ fontSize: '0.95vw', height: '2.5vw', minHeight: '2.5vw' }} value={'bill_wise'}>{'Bill Wise'}</MenuItem>
                                                                                    <MenuItem sx={{ fontSize: '0.95vw', height: '2.5vw', minHeight: '2.5vw' }} value={'admission_wise'}>{'Admission Wise'}</MenuItem>
                                                                                </Select>
                                                                            </Box> 
                                                                                        : Module === 'Discharge Summary Left Margin' ?
                                                                                            <Box display={"flex"}>
                                                                                                <TextField
                                                                                                    size='small'
                                                                                                    variant="outlined"
                                                                                                    sx={{ width: '15vw', fontSize: '0.95vw' }}
                                                                                                    value={this.state.discharge_summary_left_margin}
                                                                                                    onChange={(event) => {
                                                                                                        let value = event.target.value;
                                                                                                        const isValid = CommonValidation.NumberWithDot(value)
                                                                                                        if (isValid) {
                                                                                                            const numericValue = parseFloat(value);
                                                                                                            if (value === "" || (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 7.5)) {
                                                                                                                this.setState({ discharge_summary_left_margin: value });
                                                                                                            }
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </Box>
                                                                            
                                                                        : "-"
                } </Box>
        )
    }

    msgClose = () => {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            isInformMsg: false,
            isInformMsgText: ''
        })
    }
    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }
    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    warningMessage = (message) => {
        this.setState({
            isInformMsg: true,
            isInformMsgText: message
        })
    }

    render() {
       
        const { t } = this.props;
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={13}>
                        <Paper className="eMed_srvConfig_Div" >
                            <Box component={'div'}>
                                <TableContainer component={'div'} className="eMed_ABill_Tbl">
                                    <Table aria-label="collapsible table" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ width: '10vw' }} align='center' className="eMed_ABill_Head">{t('S.No')}</TableCell>
                                                <TableCell sx={{ width: '60vw' }} className="eMed_ABill_Head">{t('Type')}</TableCell>
                                                <TableCell sx={{ width: '10vw' }} className="eMed_ABill_Head">{t("Block")}</TableCell>
                                                <TableCell sx={{ width: '20vw' }} className="eMed_ABill_Head">{t("Amount Limit")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {this.state?.Custom_Config_List.map((item, index) => {
                                            return (
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell sx={{ width: '10vw' }} align='center' className="eMed_ABill_Tblcell">{index + 1}</TableCell>
                                                        <TableCell sx={{ width: '60vw' }} className="eMed_ABill_Tblcell">{item.module}</TableCell>
                                                        <TableCell sx={{ width: '10vw' }} className="eMed_ABill_Tblcell">
                                                            {this.BlockBills(item)}
                                                        </TableCell>
                                                        <TableCell sx={{ width: '20vw' }} className="eMed_ABill_Tblcell">
                                                            {this.CreditLimit(item)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )
                                        }
                                        )}
                                    </Table>
                                </TableContainer>
                            </Box>
                            <div className='eMed_TestConfig_RightBtnCon'>
                                <Stack display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                    <Button size='small' id='eMed_Btn_Text' variant='contained' emed_tid="CustomConfig_Save_Btn"
                                        disabled={this.state.disableBtn ? true : !CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Custom Configuration", "SubTab")?.editAccess}
                                        onClick={() => {
                                            if(!this.state.is_room_charge_gst_applicable && (!this.state.GSTAmount || !this.state.GSTPercent) && isNewBilling) {
                                                this.errorMessage("Please enter GST Amount and select GST Percent.")
                                            } else if(!this.state.is_expense_maximum_enabled && this.state.expense_maximum_amount === ''){
                                                this.errorMessage('Please enter expense maximum limit')
                                            } else {
                                                this.updateCustomDetails()
                                            }
                                            
                                        }}>{t("Save")}</Button>
                                </Stack>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)} /> : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)} /> : null}
                {this.state.isInformMsg ?
                    <ToastMsg
                        severity={'warning'}
                        msg={this.state.isInformMsgText}
                        msgPop={this.msgClose.bind(this)} /> : null}
                <Dialog
                    open={this.state.PharmaFOLinkPoP && Object.keys(this.state.PharmaFOLinkPoP).length > 0}
                >
                    <Box component={'div'} className="eMed_cnf_Box">
                        <DialogTitle id="alert-dialog-title" sx={{ color: 'red', fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                            <WarningAmberIcon sx={{ marginRight: '0.5vw' }} /> Warning
                        </DialogTitle>
                        <Box component={'div'} className="eMed_cnf_BtnGr">
                            <IconButton onClick={() => { this.setState({ PharmaFOLinkPoP: {} }) }}>
                                <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' />
                            </IconButton>
                        </Box>
                    </Box>
                    <DialogContent dividers sx={{ width: "30vw" }}>
                        <DialogContentText color={'#7a7676'}>{`If you block pharmacy bills from front office module, it may affect the accounts (reports).`}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button size='small' variant="outlined" color='error' onClick={() => { this.setState({ PharmaFOLinkPoP: {} }) }}>Cancel</Button>
                        <Button size='small' variant="contained" color='error' onClick={() => {
                            let states = this.state
                            states[this.state.PharmaFOLinkPoP?.state] = this.state.PharmaFOLinkPoP?.value
                            this.setState({ states }, () => {
                                if (this.state.PharmaFOLinkPoP?.state === "LinkPharmaBilltoFO") {
                                    if (states?.LinkPharmaBilltoFO) {
                                        this.setState({ pharmaCreditPay: true })
                                    }
                                }
                                this.setState({ PharmaFOLinkPoP: {} })
                            })
                        }}>Confirm</Button>
                    </DialogActions>
                </Dialog>
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        );
    }
}

export default withTranslation()(CustomConfig);